import { Directive, ElementRef, HostListener } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[select]' })
export class SelectDirective {
	private el: HTMLInputElement;
	constructor(private elementRef: ElementRef) {
		this.el = this.elementRef.nativeElement;
	}
	@HostListener('focus')
	onFocus() {
		this.el.select();
	}
}
